module.exports = __webpack_public_path__ + "img/hihat_example_alert2.160bddd1.gif";